import { Stack, Typography } from '@mui/material'

import ApiDocsVersionToggle from './ApiDocsVersionToggle'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import { FunctionComponent } from 'react'
import { NavLink } from 'react-router-dom'
import ProfileMenu from './ProfileMenu'
import SearchAPIDocs from './SearchAPIDocs'
import SwitchActiveTenant from './SwitchActiveTenant'
import Toolbar from '@mui/material/Toolbar'

const NavBar: FunctionComponent = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar component="nav" position="static" sx={{ backgroundColor: '#1F354E' }}>
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            py: 2,
            px: { xs: 4 }
          }}
        >
          <NavLink to="/">
            <Stack direction="row" spacing={1} alignItems="center">
              <Box component="img" src="/logo.png" alt="Angaza logo" sx={{ height: 33 }} />
              <Typography>Developer Portal</Typography>
            </Stack>
          </NavLink>

          <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="center">
            <ApiDocsVersionToggle />

            <SearchAPIDocs />

            <SwitchActiveTenant />
            <ProfileMenu />
          </Stack>
        </Toolbar>
      </AppBar>
    </Box>
  )
}

export default NavBar
